import Login from './Login.i18n';
import Action from './Action.i18n';
import System from './System';
import Mail from './Mail';

//import LogDetail from './Log.Detail';

const Logs = {
  Login, Action, System, Mail
}
export default Logs
export {
  Login, Action, System, Mail
}
